// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getTransaction: "/transaction/record/page/v2",
    queryRecordAllowed: "/web/transaction/record/query_allowed",
    //
    initExportTransaction: "/web/transaction/record/page/v2/export"
};

const initExportTransaction = (request) => axios.get(API_ENDPOINTS.initExportTransaction, { params: { ...request } });

// ----------------------------------------------------------------------

const {
    useGetTransactionListQuery,
    useQueryTransactionRecordAllowedQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getTransactionList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "TransactionList" ],
            query: (request) => `${ API_ENDPOINTS.getTransaction }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        queryTransactionRecordAllowed: builder.query({
            query: () => API_ENDPOINTS.queryRecordAllowed,
            transformResponse: ({ data }) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    initExportTransaction as initExportTransactionAPI,
    //
    useGetTransactionListQuery,
    useQueryTransactionRecordAllowedQuery
};
